import React from 'react';
import { ArrowUpRight, MapPin } from 'lucide-react';
import { fileUrl } from '../../api';

export default function Projects({ projects, compact = false }) {
  const items = compact ? projects.slice(0, 4) : projects;
  return (
    <section id="proiecte" className="py-20 md:py-28 bg-slate-50 border-y border-slate-200">
      <div className="egea-container">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div className="max-w-[640px]">
            <span className="section-eyebrow">Proiecte</span>
            <h2 className="font-display font-bold uppercase tracking-tight text-slate-900 text-3xl md:text-4xl leading-[1.05] mt-4">
              Lucrări care<br />vorbesc pentru noi.
            </h2>
          </div>
          {compact && (
            <a href="/proiecte" className="btn-ghost px-5 py-2.5 text-[13px] uppercase tracking-wide flex items-center gap-1.5 self-start">
              Toate proiectele <ArrowUpRight size={16} />
            </a>
          )}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {items.map((p) => (
            <div key={p.id} className="group relative overflow-hidden border border-slate-200 card-hover min-h-[320px] flex items-end bg-slate-900">
              <img
                src={fileUrl(p.image)}
                alt={p.title}
                loading="lazy"
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-950 via-slate-950/50 to-transparent" />
              <div className="relative p-7 w-full">
                <div className="flex items-center gap-3 mb-3">
                  <span className="text-[11px] tracking-[0.15em] uppercase font-bold text-slate-900 bg-[#f5a524] px-2.5 py-1">
                    {p.type}
                  </span>
                  <span className="text-[12px] text-slate-300">{p.year}</span>
                </div>
                <h3 className="font-display font-bold text-white text-2xl leading-tight mb-2">{p.title}</h3>
                <div className="flex items-center gap-1.5 text-[13px] text-slate-300 mb-3">
                  <MapPin size={14} className="text-[#f5a524]" /> {p.location}
                </div>
                <p className="text-[13.5px] text-slate-300 leading-relaxed max-w-[440px]">{p.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
